"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLoaderTemplate = void 0;
const lit_html_1 = require("lit-html");
/**
 * Возвращает шаблон лоадера
 */
function getLoaderTemplate(shown, translations) {
    return shown ? (0, lit_html_1.html) `
        <div class="art-ajaxer-loader">
            <div class="preloader">
                <div class="preloader__img">
                    <img src="/img/preloader.svg" />
                </div>
                <h2 class="preloader__title">${translations.instant('loading')}</h2>
                <p class="preloader__txt">${translations.instant('pleasewait')}</p>
            </div>
        </div>
    ` : null;
}
exports.getLoaderTemplate = getLoaderTemplate;
